<template lang="pug">
  label.info-tooltip(:class="showTooltip ? 'active' : 'deactive'")
    i.icon-info.fo.fo-exclamation(@click.stop="showTooltip = true")

    .hint(@click.stop="() => {}")
      span {{ infoText }}
      i.fo.fo-delete(@click.stop="showTooltip = false")

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class NInfoTooltip extends Vue {
  @Prop({ type: String, default: '' }) infoText

  showTooltip = false

  mounted () {
    window.addEventListener('click', () => {
      this.showTooltip = false
    })
  }
}
</script>
